import Exclamation from '../../src/legacy/Exclamation';
export default Exclamation;
